import { render, staticRenderFns } from "./SearchTabRoleForm.vue?vue&type=template&id=1028527c&scoped=true&"
import script from "./SearchTabRoleForm.vue?vue&type=script&lang=js&"
export * from "./SearchTabRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchTabRoleForm.vue?vue&type=style&index=0&id=1028527c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028527c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VTextField})
